import axios from "axios";
import { URL_BASE } from "@/configs/constants";

const RESOURCE = 'provider';
export default {

    loadProviders(context, params) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, { params })
                .then(response => {
                    context.commit('LOAD_PROVIDERS', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                    return reject(errors)
                })
        })
    },

    storeProvider(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}${RESOURCE}`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => { })
        })
    },

    loadProvider(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                .then(response => resolve(response.data))
                .catch((e) => reject(e))
        })
    },

    updateProvider(context, formData) {
        return new Promise((resolve, reject) => {
            axios.put(`${URL_BASE}${RESOURCE}/${formData.id}`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => context.commit('PRELOADER', false))
        })
    },

    searchCNPJProvider(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}provider-exist`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(()=> {
                    errors => reject(errors)
                })

        })
    },

    searchCPFProvider(context, formData) {
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}provider-exist`, formData)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
        })
    },

    updateProviderPhoto(context, formData) {
        let config = { headers: { 'Content-Type': 'multipart/form-data' } }
        return new Promise((resolve, reject) => {

            axios.post(`${URL_BASE}provider-photo`, formData, config)
                .then((r) => {
                    resolve(r)
                })
                .catch(errors => reject(errors))
                .finally(() => { })
        })
    }

}